import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { moment } from '../lib/moment';
import { Pipe, PipeTransform } from '@angular/core';
import { MomentFormatter } from '../services/moment-formatter';
import { Moment } from 'moment';

const INTERVAL = 60000; // 1 min

@Pipe({ name: 'elapsedTimeLive' })
export class ElapsedTimeLivePipe implements PipeTransform {

  constructor(
    private formatter: MomentFormatter,
  ) { }

  public transform(
    updatedAt: string,
    thresholdForLive: number,
    prefixString: string = '',
    postFixString: string = '',
    useUserTimezone: boolean = true,
    isDateOnly: boolean = false,
  ): Observable<string> {
    if (!updatedAt) return;
    return timer(0, INTERVAL)
      .pipe(
        map(() => this.format(updatedAt, thresholdForLive, prefixString, postFixString, useUserTimezone, isDateOnly)),
      )
    ;
  }

  private format(
    updatedAt: string,
    thresholdForLive: number,
    prefixString: string,
    postFixString: string,
    useUserTimezone: boolean,
    isDateOnly: boolean,
  ): string {
    const now = moment();
    const updatedAtDate = moment(updatedAt);
    const timeDiff = now.diff(updatedAtDate, 'seconds');
    const timeDiffInMins: number = Math.floor(timeDiff / 60) % 60;
    const timeDiffInDays: number = Math.floor(timeDiff / (24 * 3600));
    const remainingHoursInDay: number = Math.floor((timeDiff % (24 * 3600)) / 3600);
    let updatedAtLabel: string;

    const formatWithSuffix = (timeString: string) => {
      // The word "hace" is spanish translation for "ago" and it appears before the time duration
      if (postFixString.length && postFixString === 'hace') {
        return `${postFixString} ${timeString}`;
      }

      return `${timeString} ${postFixString}`;
    };

    if (isDateOnly) return this.formateDate(now, updatedAtDate, useUserTimezone);
    if (timeDiff <= thresholdForLive) {
      updatedAtLabel = 'Live';
    } else if (timeDiffInDays < 1) {
      const formattedHoursAndMinutes = remainingHoursInDay ? `${remainingHoursInDay}h ${timeDiffInMins}m` : `${timeDiffInMins}m`;
      updatedAtLabel = formatWithSuffix(prefixString ? `${prefixString} ${formattedHoursAndMinutes}` : formattedHoursAndMinutes);
    } else if (timeDiffInDays >= 1 && timeDiffInDays <= 6) {
      const formattedDaysAndHours = remainingHoursInDay ? `${timeDiffInDays}d ${remainingHoursInDay}h` : `${timeDiffInDays}d`;
      updatedAtLabel = formatWithSuffix(prefixString ? `${prefixString} ${formattedDaysAndHours}` : formattedDaysAndHours);
    } else updatedAtLabel = this.formateDate(now, updatedAtDate, useUserTimezone);
    return updatedAtLabel;
  }

  private formateDate(now: Moment, updatedAtDate: Moment, useUserTimezone: boolean): string {
    if (now.isSame(updatedAtDate, 'year')) {
      return this.formatter.format(updatedAtDate, 'MM/DD', useUserTimezone);
    }
    return this.formatter.format(updatedAtDate, 'MM/DD/YY', useUserTimezone);
  }
}
